import React from 'react';
import { BaseCell, CurrencyInput, InputAddon, InputGroup } from '../../../../../../../components';
import { RuleDataItem } from '../../lib/service';
import styles from './RulesPageTableFactorCell.module.scss';

const FACTOR_MULTIPLIER = 100;
const NOT_APPLICABLE = '--';

const RulesPageTableFactorCell = ({ mechanism }: RuleDataItem) => {
  // "Margem objetiva" não tem fator de regra: o cadastro nem exibe o campo para esse mecanismo,
  // então a coluna segue o padrão de campo não aplicável em vez de sugerir um fator de 0%.
  const hasNoApplicableFactor = mechanism?.mechanismType === 'MARGEM_OBJETIVA';

  if (hasNoApplicableFactor || mechanism?.factor == null) return <BaseCell>{NOT_APPLICABLE}</BaseCell>;

  return (
    <BaseCell>
      <div className={styles.wrapper}>
        <InputGroup className={styles['input-group']}>
          <CurrencyInput value={mechanism.factor * FACTOR_MULTIPLIER} allowEmpty={false} disabled precision={1} />
          <InputAddon>%</InputAddon>
        </InputGroup>
      </div>
    </BaseCell>
  );
};

export default RulesPageTableFactorCell;
